import { http } from '../../../../api/axios';
import { ProductsResponseOut } from '../../../../store/api';
import { shopPrefix } from '../../../../config';
import { CompleteCollectionParams } from './useCompleteCollectionProducts';
const endpoint = `${shopPrefix}/v2/collection/complete/products`;

export const fetchCompleteCollectionProducts = (params: CompleteCollectionParams) => {
    return http
        .post<ProductsResponseOut>(endpoint, params.filterMap, {
            params: {
                loanFormat: params?.loanFormat,
                page: params?.pagination.page,
                pageSize: params?.pagination.pageSize,
                sortBy: params?.pagination.sortBy,
                ageCategory: params?.ageCategory
            }
        })
        .then(res => res.data);
};
